import { render, staticRenderFns } from "./StoreSettings.vue?vue&type=template&id=4aa780cd&scoped=true"
import script from "./StoreSettings.vue?vue&type=script&lang=js"
export * from "./StoreSettings.vue?vue&type=script&lang=js"
import style0 from "./StoreSettings.vue?vue&type=style&index=0&id=4aa780cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa780cd",
  null
  
)

export default component.exports